import type { HumanizedShoppingList, ShoppingItem } from "../models";

/** One line per item ("chicken breast: 450 g"), the text `humanizeShoppingList` reads best. */
export function shoppingListText(items: ShoppingItem[]): string {
  return items
    .filter((i) => i.name?.trim())
    .map((i) => {
      const amount = [i.portionQuantity, i.portionSize].filter((x) => x !== undefined && x !== null && x !== "").join(" ");
      return amount ? `${i.name.trim()}: ${amount}` : i.name.trim();
    })
    .join("\n");
}

/** `humanizeShoppingList` output as items `convertShoppingList` accepts. */
export function humanizedToShoppingItems(list: HumanizedShoppingList | null | undefined): ShoppingItem[] {
  return (list?.items ?? [])
    .map((i) => ({ name: (i.shoppingName || i.name || "").trim(), portionQuantity: i.quantity, portionSize: i.unit || undefined }))
    .filter((i) => i.name);
}
